// extracted by mini-css-extract-plugin
export default {"container":"GlobalMessages_container__Qv9Cd","toggleMessagesButton":"GlobalMessages_toggleMessagesButton__Z6G0V"};